module.exports = __webpack_public_path__ + "img/Til-ungdommen_Forste-bilde-under-Journalisten-og-krigsreporteren.e7623f07.jpg";